import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { IpetState } from "./pet.types";

const selectDomain = (state: any) => state.petReducer;

export const pet = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.pet
);

export const singlePet = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.singlePet
);

export const successMessage = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.petSuccessMesssage
);

export const petError = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.petError
);

export const petActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.isPetActivityInProcess
);

export const petDeleteInProcess = createDraftSafeSelector(
  selectDomain,
  (pet: IpetState) => pet.isPetDeleteInProcess
);
